import 'css-chunksrc/client/scenes/projectMaterialResourceAddition/styles.scss';export default {
  "group": "_group_ywp2f_1",
  "text": "_text_ywp2f_5",
  "name": "_name_ywp2f_10",
  "main": "_main_ywp2f_16",
  "buttons": "_buttons_ywp2f_23",
  "button": "_button_ywp2f_23"
};